module.exports = __webpack_public_path__ + "img/cp-04.bab8368f.png";